(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feel-bestsellers"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Quick Add — feel-bestsellers
     Posts first available variant as one-time purchase (no selling_plan).
     On success dispatches feel:cart-updated → feel-cart-drawer opens + refreshes. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.fb-quick-add');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    var orig = btn.textContent.trim();
    btn.textContent = '…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      /* No selling_plan key → Shopify adds as one-time purchase */
    })
    .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
    .then(function () {
      btn.textContent = '✓ Added';
      document.dispatchEvent(new CustomEvent('feel:cart-updated', { bubbles: true }));
      setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 2000);
    })
    .catch(function () {
      btn.textContent = orig;
      btn.disabled = false;
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
